import { ExperienceTemplateRenderer, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { UitkLayoutGrid } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';

import { z } from 'zod';
import { useBexApi } from '@shared-ui/bex-api-context';
import { useExperiment } from '@shared-ui/experiment-context';

export const ResultsWrapper: React.FC<TemplateComponentProps> = ({ templateComponent }) => {
  const { children, config } = templateComponent;

  const { context } = useBexApi();
  const isMobileWeb = context.device.type === ('MOBILE_PHONE' || 'MOBILE_TABLET');
  const quickFiltersExperimentName = `Introduce_Quick_Sort_and_Filters_at_top_of_SRP_${isMobileWeb ? 'mweb' : 'web'}`;
  const { exposure } = useExperiment(quickFiltersExperimentName);
  const isControl = exposure.bucket === 0;

  const configSchema = z.optional(
    z.object({
      columns: z.number(),
      space: z.any(),
    })
  );
  const result = configSchema.safeParse(config);

  if (!result.success || !children || children.length === 0) {
    return null;
  }

  const { columns, space } = result.data ?? {};

  return (
    <UitkSpacing
      padding={
        isControl
          ? {
              small: { block: 'three' },
              medium: { blockstart: 'one' },
              large: { blockstart: 'three' },
            }
          : {
              blockstart: 'two',
            }
      }
    >
      <div className="search-results-listing">
        <Viewport>
          <ViewLarge>
            <UitkLayoutGrid columns={columns} space={space}>
              {children && <ExperienceTemplateRenderer templateComponents={children} />}
            </UitkLayoutGrid>
          </ViewLarge>
          <ViewSmall>
            <UitkLayoutGrid columns={1}>{children && <ExperienceTemplateRenderer templateComponents={children} />}</UitkLayoutGrid>
          </ViewSmall>
        </Viewport>
      </div>
    </UitkSpacing>
  );
};
